import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Clinic } from '../../../common/model/dto/clinic';
import { AdminClinicService } from '../../../services/admin/admin-clinic.service';
import OvLabelledValue from '../atoms/OvLabelledValue';
import OvSearchTypeahead from './OvSearchTypeahead';

interface OvClinicTypeaheadProps {
  placeholder?: string;
  onClinicSelect?: (clinic: Clinic | null) => void;
  className?: string;
}

const OvClinicTypeahead: FC<OvClinicTypeaheadProps> = ({
  placeholder,
  onClinicSelect,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <OvSearchTypeahead<Clinic>
      searchKey="admin-clinics"
      fetchOptions={AdminClinicService.getClinicTypeahead}
      getOptionLabel={({ name }) => name ?? ''}
      onSelect={onClinicSelect}
      placeholder={placeholder}
      className={className}
      renderOption={(props, { name }) => (
        <OvLabelledValue
          {...props}
          items={
            name
              ? [{ label: t('common.clinicFields.clinicName'), value: name }]
              : []
          }
        />
      )}
    />
  );
};

export default OvClinicTypeahead;
